import { QuestionProps } from '@zapier/design-system-revenue/src/types';

/**
 * Example output:
 * {
 *   comments: 'The national animal of Scotland is the unicorn.',
 *   option_1: 'I only needed Zapier temporarily',
 *   option_2: 'I found another solution',
 *   option_3: 'Other',
 *   reason_1: 'I only needed Zapier temporarily',
 *   reason_2: 'Other',
 * }
 *
 * A reason is an option that the user selected on the downgrade survey.
 * An option is a potential reason for downgrading that was shown to the user on the downgrade survey.
 */
export const formatDowngradeSurveyFeedback = (
  options: Array<QuestionProps>,
  comments: string = ''
) => {
  const formattedOptions = options.reduce(
    (accumulator, option, index) => ({
      ...accumulator,
      [`option_${index + 1}`]: option.question,
    }),
    {}
  );

  const formattedReasons = options
    .filter(o => o.isChecked)
    .reduce(
      (accumulator, option, index) => ({
        ...accumulator,
        [`reason_${index + 1}`]: option.question,
      }),
      {}
    );

  return {
    comments,
    ...formattedOptions,
    ...formattedReasons,
  };
};
